import { useQuery, UseQueryOptions } from '@tanstack/react-query';

// helpers
import { BaseError } from '../../helpers/BaseError';

import useGetCurrentMessageContent from '../../hooks/message-content/useGetCurrentMessageContent';

// models
import { GenericMessagePreviewModel } from '../../models/editor.model';

// services
import API from '../../services/api';

import formulaKeys from './_queryKeys';

const generateMessages = async (
    formulaId: number,
    preview_count?: number,
    messageContentId?: string,
): Promise<GenericMessagePreviewModel[]> => {
    const params: Record<string, string | number> = {};
    if (messageContentId) {
        params.message_content_id = messageContentId;
    }
    if (preview_count) {
        params.preview_count = preview_count;
    }
    const { data } = await API.generateMessages(formulaId, params);

    return data;
};

export default function useMessageGenerationQuery(
    formulaId: number,
    preview_count?: number,
    options?: UseQueryOptions<any, BaseError>,
) {
    const { currentMessageContentId } = useGetCurrentMessageContent(formulaId);
    return useQuery<GenericMessagePreviewModel[], BaseError>({
        queryKey: formulaKeys.formulaMessages(
            formulaId,
            currentMessageContentId,
            preview_count,
        ),
        queryFn: () =>
            generateMessages(formulaId, preview_count, currentMessageContentId),
        retry: false,
        enabled: !!formulaId,
        ...options,
    });
}
